import { all, call, put, takeEvery } from "redux-saga/effects";
import {
  servicesAdminShowContactMessage,
  setServicesCategory,
  setServicesBusinessCategory,
  submitNewServicesAdminResponse,
  submitEditServicesDetailsResponse,
  deleteServiceResponse,
  servicesFailResponse,
  haveAppointmentDeleteServices,
  appointmentDeleteServicesForcefullyResponse,
  addServiceBusinessCategory
} from "../actions";
import axios from "../services/admin";
import {
  GET_SERVICES_CATEGORY,
  SUBMIT_NEW_SERVICES_ADMIN,
  DELETE_SERVICE,
  APPOINTMENT_DELETE_SERVICES_FORCEFULLY,
} from "../constants/ActionTypes";

function* fetchServicesRequest() {
  try {
    const fetchedCategory = yield axios.get("/servicecategories");
    yield put(setServicesCategory(fetchedCategory.data));
    const businessLocation = localStorage.getItem("business_location");
    const fetchedBusinessCategory = yield axios.get(`/servicecategorybybusinesses?location=${businessLocation}`);
    yield put(setServicesBusinessCategory(fetchedBusinessCategory.data));
  } catch (error) {
    console.log("TCL: function*fetchServicesRequest -> error", error)
    // yield put(servicesFailResponse(error.response.data.message));
  }
}

function* submitNewService({ payload }) {
  try {
    const { formValues } = payload;
    const {
      addServicesState,
      editServicesState,
      selectedCategory,
      selectedService,
      customService,
      description,
      price,
      duration,
      contactList,
      selectedServiceId,
      businessCategoryArray
    } = formValues;

    const durationSend = duration * 60;

    const businessLocation = localStorage.getItem("business_location");
    let categoryId = null;
    let custom_service = false;

    for (let i = 0; i < businessCategoryArray.length; i++) {
      console.log("businessCategoryArray", businessCategoryArray)
      if (businessCategoryArray[i] != undefined && businessCategoryArray[i].name === selectedCategory) {
        categoryId = businessCategoryArray[i]._id;
        console.log("TCL: function*submitNewService -> categoryId1", categoryId)
        break;
      }
    }
    if (!categoryId) {
      console.log("TCL: function*submitNewService -> categoryId2", categoryId)
      const findCategory = yield axios.post("servicecategorybybusinesses", {
        name: selectedCategory,
        location: businessLocation,
      });

      // categoryId = findCategory.data._id;
      let categoryData = findCategory.data;
      categoryId = categoryData._id;
      yield put(addServiceBusinessCategory(categoryData))
      console.log("TCL: function*submitNewService -> categoryId3", categoryId)

    }

    let serviceName = selectedService;

    if (selectedService == "Other") {
      serviceName = customService;
      custom_service = true;
    }

    if (addServicesState) {
      const addRequestObject = {
        name: serviceName,
        description,
        price,
        custom_service,
        duration: durationSend,
        category: categoryId,
        location: businessLocation,
      };

      //
      const response = yield axios.post("servicesbybusinesses", addRequestObject);
      yield put(submitNewServicesAdminResponse(response.data));
      // yield put(addServiceBusinessCategory(response.data))

    } else if (editServicesState) {
      const editRequestObject = {
        name: serviceName,
        description,
        price,
        custom_service,
        duration: durationSend,
        category: categoryId,
        location: businessLocation,
      };

      const response = yield axios.put(
        `servicesbybusinesses/${selectedServiceId}`,
        editRequestObject
      );

      yield put(submitEditServicesDetailsResponse(response.data));
    }
  } catch (error) {
    console.log("TCL: function*submitNewService -> error", error)
    // yield put(servicesFailResponse(error.response.data.message));
  }
}

function* deleteServices({ payload }) {
  try {
    //
    const { contactList } = payload;
    const deleteServicesSelected = contactList.filter(item => item.selected);
    const deleteServicesIds = deleteServicesSelected.map(item => item._id);
    const deletedRequestApis = deleteServicesIds.map(id =>
      axios.delete(`servicesbybusinesses/${id}`)
    );
    const response = yield Promise.all(deletedRequestApis);
    const deleteServices = [];
    const dontDeleteServices = [];
    response.forEach(element => {
      if (element.data.message === "active_appointment_found_for_deleted_service") {
        dontDeleteServices.push(element.data._id);
      } else {
        deleteServices.push(element.data._id);
      }
    });

    if (dontDeleteServices.length === 0) {
      yield put(deleteServiceResponse({ deleteServices }));
    } else {
      yield put(haveAppointmentDeleteServices({ dontDeleteServices, deleteServices }));
    }
  } catch (error) {
    yield put(servicesFailResponse(error.response.data.message));
  }
}

function* deleteServicesForcefully({ payload }) {
  try {
    const deletedRequestApis = payload.map(id =>
      axios.delete(`servicesbybusinesses/${id}?forcefully=true`)
    );
    const response = yield Promise.all(deletedRequestApis);
    yield put(appointmentDeleteServicesForcefullyResponse());
  } catch (error) {
    yield put(servicesFailResponse(error.response.data.message));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(GET_SERVICES_CATEGORY, fetchServicesRequest),
    takeEvery(SUBMIT_NEW_SERVICES_ADMIN, submitNewService),
    takeEvery(DELETE_SERVICE, deleteServices),
    takeEvery(APPOINTMENT_DELETE_SERVICES_FORCEFULLY, deleteServicesForcefully),
  ]);
}



// WEBPACK FOOTER //
// ./sagas/ServicesAdminSaga.js